import { EventCategory, EventSchedule } from 'oc2api/popup';
import { safeParseTime, isSameDay, formatTime, formatDayAndTime } from 'lib/dayjs';

const eventCategoryToTextMap: Record<EventCategory, string> = {
  seminar: '説明会・セミナー',
  internship: 'インターン',
  entry: '本選考',
};

export function eventCategoryToText(category: EventCategory): string {
  return eventCategoryToTextMap[category];
}

export function isOnlineSchedule(schedule: EventSchedule): boolean {
  return !!schedule.live_url
}

export function formatScheduleTime(schedule: EventSchedule): string | undefined {
  const startTime = safeParseTime(schedule.start_at);
  const endTime = safeParseTime(schedule.end_at);

  if (startTime != null || endTime != null) {
    const formattedEndTime = isSameDay(startTime, endTime) ? formatTime(endTime) : formatDayAndTime(endTime);
    return [formatDayAndTime(startTime), '〜', formattedEndTime].join(' ');
  }
}
